import { createFileRoute } from "@tanstack/react-router";
import { computeSearch } from "../../features/console/compute-selection";
import { JobNew } from "../../features/runs/job-new";

export const Route = createFileRoute("/_authed/$org/$project/jobs/new")({
  validateSearch: (s: Record<string, unknown>) => {
    return {
      ...(typeof s.from === "string" ? { from: s.from } : {}),
      ...computeSearch(s),
      ...(typeof s.pool === "string" && /^[a-z0-9]([-a-z0-9]{0,61}[a-z0-9])?$/.test(s.pool) ? { pool: s.pool } : {}),
    };
  },
  component: NewJobPage,
});

function NewJobPage() {
  const { org, project } = Route.useParams();
  const { from, pool, ...compute } = Route.useSearch();
  return <JobNew scope={{ org, project }} {...(from ? { from } : {})} compute={compute} {...(pool ? { pool } : {})} />;
}
